"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _applet = require("@/api/operation/applet");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      applyStatusOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '待处理',
        value: 'PENDING',
        tag: 'cyan'
      }, {
        label: '通过审核',
        value: 'APPROVED',
        tag: 'green'
      }, {
        label: '已拒绝',
        value: 'REJECTED',
        tag: 'red'
      }, {
        label: '处理中',
        value: 'PROCESSING',
        tag: 'orange'
      }],
      paymentTypeOptions: [{
        label: '微信',
        value: 'WECHAT',
        tag: 'green'
      }, {
        label: '支付宝',
        value: 'ALIPAY',
        tag: 'blue'
      }],
      channelVersionOptions: [{
        label: '小程序',
        value: 'routine',
        tag: 'cyan'
      }, {
        label: '公众号',
        value: 'wechat',
        tag: 'green'
      }, {
        label: '支付宝',
        value: 'alipay',
        tag: 'blue'
      }, {
        label: 'H5',
        value: 'h5',
        tag: 'orange'
      }],
      transferStatusOptions: [{
        label: '受理成功',
        value: 'ACCEPTED'
      }, {
        label: '处理中',
        value: 'PROCESSING'
      }, {
        label: '待用户收款确认',
        value: 'WAIT_USER_CONFIRM'
      }, {
        label: '转账中',
        value: 'TRANSFERING'
      }, {
        label: '转账成功',
        value: 'SUCCESS'
      }, {
        label: '转账失败',
        value: 'FAIL'
      }, {
        label: '撤销中',
        value: 'CANCELING'
      }, {
        label: '撤销完成',
        value: 'CANCELLED'
      }],
      withdrawTotalAmount: '0',
      multipleSelection: [],
      checkIds: [],
      auditOptions: [{
        label: '同意',
        value: 'APPROVE'
      }, {
        label: '拒绝',
        value: 'REJECT'
      }],
      appList: [],
      batchModal: {
        show: false,
        data: {
          auditAction: '',
          auditComment: ''
        },
        totalAmount: 0,
        totalCount: 0,
        amountList: []
      }
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '用户ID',
        prop: 'userId',
        defaultValue: '',
        type: 'input'
      },
      // { label: '用户昵称', prop: 'userNickname', defaultValue: '', type: 'input' },
      // { label: '用户手机', prop: 'userPhone', defaultValue: '', type: 'input' },
      {
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }, {
        label: '提现金额',
        prop: 'withdrawAmount',
        defaultValue: undefined,
        type: 'input-number',
        options: {
          min: 0,
          step: 0.01,
          stepStrictly: true,
          controlsPosition: 'right'
        }
      }, {
        label: '申请状态',
        prop: 'applyStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.applyStatusOptions
        }
      }, {
        label: '转账状态',
        prop: 'transferStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.transferStatusOptions
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'startApplyTime',
          endKey: 'endApplyTime',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 230
      }, {
        key: 'user',
        visible: true,
        label: "\u7528\u6237",
        width: 200
      }, {
        key: 'applicationName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 160
      }, {
        key: 'withdrawTypeDesc',
        visible: true,
        label: "\u63D0\u73B0\u7C7B\u578B",
        width: 100
      }, {
        key: 'withdrawAmount',
        visible: true,
        label: "\u63D0\u73B0\u91D1\u989D",
        width: 100
      }, {
        key: 'paymentType',
        visible: true,
        label: "\u4EA4\u6613\u65B9\u5F0F",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: this.paymentTypeOptions
        }
      }, {
        key: 'applyStatus',
        visible: true,
        label: "\u7533\u8BF7\u72B6\u6001",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: this.applyStatusOptions
        }
      }, {
        key: 'channelVersion',
        visible: true,
        label: "\u6E20\u9053\u6765\u6E90",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: this.channelVersionOptions
        }
      }, {
        key: 'transferStatus',
        visible: true,
        label: "\u8F6C\u8D26\u72B6\u6001",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: this.transferStatusOptions
        }
      }, {
        key: 'auditComment',
        visible: true,
        label: "\u5907\u6CE8",
        width: 160
      }, {
        key: 'failReason',
        visible: true,
        label: "\u5931\u8D25\u539F\u56E0",
        width: 160
      }, {
        key: 'time',
        visible: true,
        label: "\u7533\u8BF7/\u5BA1\u6838",
        width: 190
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      (0, _applet.appletListApi)(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.checkedIds = this.multipleSelection.map(function (item) {
        return item.id;
      });
    },
    getList: function getList(params) {
      return (0, _user.getWithdrawListApi)(params);
    },
    handleSearch: function handleSearch(e) {
      var _this2 = this;
      var params = _objectSpread({}, e);
      (0, _user.getWithdrawStatisticApi)(params).then(function (data) {
        _this2.withdrawTotalAmount = data;
      });
    },
    selectable: function selectable(row, index) {
      return row.applyStatus === 'PENDING';
    },
    handleApproved: function handleApproved(row) {
      var _this3 = this;
      this.$modalSure('确认同意？').then(function () {
        var params = {
          withdrawRecordId: [row.id],
          auditAction: 'APPROVE'
        };
        _this3.loading = true;
        (0, _user.auditWithdrawApi)(params).then(function (res) {
          _this3.loading = false;
          _this3.$message.success('审核成功');
          _this3.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this3.loading = false;
          _this3.$message.error('审核失败');
        });
      });
    },
    handleReject: function handleReject(row) {
      var _this4 = this;
      this.$modalSure('确认拒绝？').then(function () {
        var params = {
          withdrawRecordId: [row.id],
          auditAction: 'REJECT'
        };
        _this4.loading = true;
        (0, _user.auditWithdrawApi)(params).then(function (res) {
          _this4.loading = false;
          _this4.$message.success('审核成功');
          _this4.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this4.loading = false;
          _this4.$message.error('审核失败');
        });
      });
    },
    showBatchAudit: function showBatchAudit() {
      console.log(this.multipleSelection);
      var amountMaps = {};
      this.multipleSelection.forEach(function (item) {
        var key = parseFloat(item.withdrawAmount);
        if (!amountMaps[key]) {
          amountMaps[key] = 0;
        }
        amountMaps[key]++;
      });
      var totalAmount = 0;
      var totalCount = 0;
      var list = [];
      for (var key in amountMaps) {
        totalAmount += key * 100 * amountMaps[key];
        totalCount += amountMaps[key];
        list.push({
          amount: key,
          count: amountMaps[key]
        });
      }
      this.batchModal.totalAmount = totalAmount / 100;
      this.batchModal.totalCount = totalCount;
      this.batchModal.amountList = list;
      this.batchModal.data.auditAction = '';
      this.batchModal.data.auditComment = '';
      this.batchModal.show = true;
    },
    handleBatchAudit: function handleBatchAudit() {
      var _this5 = this;
      var _this$batchModal$data = this.batchModal.data,
        auditAction = _this$batchModal$data.auditAction,
        auditComment = _this$batchModal$data.auditComment;
      if (!auditAction) {
        return this.$message.error('请选择审核状态');
      }
      for (var i = 0; i < this.batchModal.amountList.length; i++) {
        var item = this.batchModal.amountList[i];
        if (item.amount > 0.1) {
          return this.$message.error('批量审核暂不支持审批大于0.1元申请');
        }
      }
      var params = {
        withdrawRecordId: this.checkedIds,
        auditAction: auditAction,
        auditComment: auditComment
      };
      this.loading = true;
      (0, _user.auditWithdrawAsyncApi)(params).then(function (res) {
        _this5.loading = false;
        _this5.$message.success('提交成功，可到批量审核记录中查看结果');
        _this5.batchModal.show = false;
        _this5.$refs.searchPage.refresh();
      }).catch(function (err) {
        _this5.loading = false;
        _this5.$message.error('审核失败');
      });
    },
    handleRemark: function handleRemark(row) {
      var _this6 = this;
      this.$modalPrompt('textarea', '备注', row.auditComment || '', {
        inputValidator: function inputValidator(value) {
          if (value && value.length > 500) {
            return '输入限制500字以内';
          }
          return true;
        }
      }).then(function (auditComment) {
        var params = {
          withdrawRecordId: row.id,
          auditComment: auditComment || ''
        };
        _this6.loading = true;
        (0, _user.updateWithdrawCommentApi)(params).then(function (res) {
          _this6.loading = false;
          _this6.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this6.loading = false;
        });
      });
    }
  }
};